// import { useFormik } from "formik";
// import * as Yup from "yup";
// import React, { useState } from "react";
// import toast from "react-hot-toast";
// // import { BUYEREGISTER } from "../../Mutation/AuthMutation";
// // import { useMutation } from "@apollo/client";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import { axiosInstance } from "../../Api/interceptors";

// const RegisterForm = () => {
//   // const [createBuyer, { loading }] = useMutation(BUYEREGISTER);
//   const navigate = useNavigate();

//   const [isPrivacyChecked, setPrivacyChecked] = useState(false);
//   const [isRefundChecked, setRefundChecked] = useState(false);
//   const [isTermsChecked, setTermsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//   // const handleImageChange = (e, type) => {
//   //   const file = e.target.files[0];
//   //   const reader = new FileReader();
//   //   reader.onloadend = () => {
//   //     switch (type) {
//   //       case "driverLicenseFront":
//   //         setPreviewDriverLicenseFront(reader.result);
//   //         break;
//   //       case "driverLicenseBack":
//   //         setPreviewDriverLicenseBack(reader.result);
//   //         break;

//   //       case "passportFront":
//   //         setPreviewPassportFront(reader.result);
//   //         break;
//   //       case "passportBack":
//   //         setPreviewPassportBack(reader.result);
//   //         break;
//   //       case "idCardFront":
//   //         setPreviewIdCardFront(reader.result);
//   //         break;
//   //       case "idCardBack":
//   //         setPreviewIdCardBack(reader.result);
//   //         break;
//   //       default:
//   //         break;
//   //     }
//   //   };
//   //   if (file) {
//   //     reader.readAsDataURL(file);
//   //   }
//   // };
//   const handleImageChange = (e, fieldName) => {
//     const file = e.target.files[0];
//     if (file) {
//       formik.setFieldValue(fieldName, file);
//       const previewUrl = URL.createObjectURL(file);
//       formik.setFieldValue(`${fieldName}Preview`, previewUrl);
//     }
//   };

//   // Delete Preview Function
//   const handleDeletePreview = (fieldName) => {
//     formik.setFieldValue(fieldName, null);
//     formik.setFieldValue(`${fieldName}Preview`, null);
//   };
//   // const handleDeletePreview = (type) => {
//   //   switch (type) {
//   //     case "driverLicenseFront":
//   //       setPreviewDriverLicenseFront(null);
//   //       break;
//   //     case "driverLicenseBack":
//   //       setPreviewDriverLicenseBack(null);
//   //       break;

//   //     case "passportFront":
//   //       setPreviewPassportFront(null);
//   //       break;
//   //     case "passportBack":
//   //       setPreviewPassportBack(null);
//   //       break;
//   //     case "idCardFront":
//   //       setPreviewIdCardFront(null);
//   //       break;
//   //     case "idCardBack":
//   //       setPreviewIdCardBack(null);
//   //       break;
//   //     default:
//   //       break;
//   //   }
//   // };

//   const registerSchema = Yup.object().shape({
//     first_name: Yup.string().required("Required"),
//     last_name: Yup.string().required("Required"),
//     username: Yup.string().required("Required"),
//     email: Yup.string().email("Invalid email").required("Required"),
//     password: Yup.string("Enter your password")
//       .min(8, "Password should be of minimum 8 characters length")
//       .required("Password is required"),
//   });
//   const verificationUrl = `https://automotor.dev-bt.xyz/emailverification/`;

//   // eslint-disable-next-line no-unused-vars
//   async function uploadimg(img) {
//     try {
//       const media = new FormData();
//       media.append("media", img);
//       const response = await axios.post(
//         "https://apiautomotor.devssh.xyz/upload-media",
//         media
//       );
//       return response.data.data[0].name;
//     } catch (error) {
//       console.error("Image upload failed", error);
//       toast.error("Image upload failed. Please try again."); 
//       throw error; 
//     }
//   }
//   const formik = useFormik({
//     initialValues: {
//       first_name: "",
//       last_name: "",
//       username: "",
//       email: "",
//       password: "",
//       dob: "",
//       country: "",
//       phone: "",
//       driving_license_front_pic: null,
//       driving_license_back_pic: null,
//       passport: null,
//       id_card_front: null,
//       id_card_back: null,
//       driverLicenseBackPreview: "",
//       driverLicenseFrontPreview: "",
//       idCardBackPreview: "",
//       idCardFrontPreview: "",
//       passportPreview: "",
//     },
//     validationSchema: registerSchema,
//     onSubmit: async (values) => {
//       setLoading(true);
//       try {
//         const formdata = new FormData();

//         const excludeKeys = [
//           "driverLicenseBackPreview",
//           "idCardFrontPreview",
//           "passportPreview",
//           "idCardBackPreview",
//           "driverLicenseFrontPreview",
//         ];

//         Object.entries({ ...values, url: verificationUrl }).forEach(
//           ([key, value]) => {
//             if (!excludeKeys.includes(key)) {
//               formdata.append(key, value);
//             }
//           }
//         );
//         const response = await axiosInstance.post("user/register", formdata);
//         if (response && response?.data) {
//           toast.success("Registered Successfully");
//           setLoading(false);
//           navigate("/");
//           toast.success("Check your email for verification link.");
//         }
//       } catch (errors) {
//         console.error("Registration failed", errors);
//         setLoading(false);
//         if (errors?.message) {
//           toast.error(errors.message);
//         }
//       }
//     },
//   });

//   console.log("🚀 ~ RegisterForm ~ values:", formik.values);
//   // Image handling inside Formik

//   const isFormValid = isPrivacyChecked && isRefundChecked && isTermsChecked;

//   return (
//     <>
//       <div
//         className="site-breadcrumb"
//         style={{ background: "url(/assets/img/breadcrumb/01.jpg)" }}
//       >
//         <div className="container">
//           <h2 className="breadcrumb-title">Register</h2>
//           <ul className="breadcrumb-menu">
//             <li>
//               <a href="index.html">Home</a>
//             </li>
//             <li className="active">Register</li>
//           </ul>
//         </div>
//       </div>

//       <div className="login-area py-120">
//         <div className="container">
//           <div className="col-md-8 mx-auto">
//             <div className="login-form">
//               <div className="login-header">
//                 <img src="/assets/img/logo/1.png" alt="" />
//                 <p>Create your Auto Motor account</p>
//               </div>
//               <form onSubmit={formik.handleSubmit}>
//                 <div className="row">
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>First Name</label>
//                       <input
//                         type="text"
//                         class="form-control"
//                         placeholder="First Name"
//                         name="first_name"
//                         onChange={formik.handleChange}
//                         value={formik.values.first_name}
//                       />
//                       {formik.errors.first_name && (
//                         <div className="error">{formik.errors.first_name}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Last Name</label>
//                       <input
//                         type="text"
//                         class="form-control"
//                         placeholder="Last Name"
//                         name="last_name"
//                         onChange={formik.handleChange}
//                         value={formik.values.last_name}
//                       />
//                       {formik.errors.last_name && (
//                         <div className="error">{formik.errors.last_name}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>User Name</label>
//                       <input
//                         type="text"
//                         class="form-control"
//                         placeholder="User Name"
//                         name="username"
//                         onChange={formik.handleChange}
//                         value={formik.values.username}
//                       />
//                       {formik.errors.username && (
//                         <div className="error">{formik.errors.username}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Email</label>
//                       <input
//                         type="email"
//                         class="form-control"
//                         placeholder="Email"
//                         name="email"
//                         onChange={formik.handleChange}
//                         value={formik.values.email}
//                       />
//                       {formik.errors.email && (
//                         <div className="error">{formik.errors.email}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Password</label>
//                       <input
//                         type="password"
//                         class="form-control"
//                         placeholder="Password"
//                         name="password"
//                         onChange={formik.handleChange}
//                         value={formik.values.password}
//                       />
//                       {formik.errors.password && (
//                         <div className="error">{formik.errors.password}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Date Of Birth</label>
//                       <input
//                         type="date"
//                         class="form-control"
//                         placeholder=""
//                         name="dob"
//                         onChange={formik.handleChange}
//                         value={formik.values.dob}
//                       />
//                       {formik.errors.dob && (
//                         <div className="error">{formik.errors.dob}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Phone</label>
//                       <input
//                         type="text"
//                         class="form-control"
//                         placeholder=""
//                         name="phone"
//                         onChange={formik.handleChange}
//                         value={formik.values.phone}
//                       />
//                       {formik.errors.phone && (
//                         <div className="error">{formik.errors.phone}</div>
//                       )}
//                     </div>
//                   </div>
//                   <div className="col-lg-6">
//                     <div class="form-group">
//                       <label>Country</label>
//                       <input
//                         type="text"
//                         class="form-control"
//                         placeholder=""
//                         name="country"
//                         onChange={formik.handleChange}
//                         value={formik.values.country}
//                       />
//                       {formik.errors.country && (
//                         <div className="error">{formik.errors.country}</div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Driver License Front */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label>Driver License (Front)</label>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="driving_license_front_pic"
//                         onChange={(e) =>
//                           handleImageChange(e, "driving_license_front_pic")
//                         }
//                       />
//                       {formik.values.driverLicenseFrontPreview && (
//                         <div
//                           style={{ position: "relative", marginTop: "10px" }}
//                         >
//                           <img
//                             src={formik.values.driverLicenseFrontPreview}
//                             alt="Preview"
//                             style={{ width: "100px" }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleDeletePreview("driving_license_front_pic")
//                             }
//                             style={{
//                               position: "absolute",
//                               top: "0",
//                               right: "0",
//                               background: "none",
//                               border: "none",
//                               cursor: "pointer",
//                               color: "red",
//                               fontSize: "20px",
//                             }}
//                           >
//                             🗑️
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Driver License Back */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label>Driver License (Back)</label>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="driving_license_back_pic"
//                         onChange={(e) =>
//                           handleImageChange(e, "driving_license_back_pic")
//                         }
//                       />
//                       {formik.values.driverLicenseBackPreview && (
//                         <div
//                           style={{ position: "relative", marginTop: "10px" }}
//                         >
//                           <img
//                             src={formik.values.driverLicenseBackPreview}
//                             alt="Preview"
//                             style={{ width: "100px" }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleDeletePreview("driving_license_back_pic")
//                             }
//                             style={{
//                               position: "absolute",
//                               top: "0",
//                               right: "0",
//                               background: "none",
//                               border: "none",
//                               cursor: "pointer",
//                               color: "red",
//                               fontSize: "20px",
//                             }}
//                           >
//                             🗑️
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* Passport */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label>Passport</label>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="passport"
//                         onChange={(e) => handleImageChange(e, "passport")}
//                       />
//                       {formik.values.passportPreview && (
//                         <div
//                           style={{ position: "relative", marginTop: "10px" }}
//                         >
//                           <img
//                             src={formik.values.passportPreview}
//                             alt="Preview"
//                             style={{ width: "100px" }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() => handleDeletePreview("passport")}
//                             style={{
//                               position: "absolute",
//                               top: "0",
//                               right: "0",
//                               background: "none",
//                               border: "none",
//                               cursor: "pointer",
//                               color: "red",
//                               fontSize: "20px",
//                             }}
//                           >
//                             🗑️
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* ID Card Front */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label>ID Card (Front)</label>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="id_card_front"
//                         onChange={(e) => handleImageChange(e, "idCardFront")}
//                       />
//                       {formik.values.idCardFrontPreview && (
//                         <div
//                           style={{ position: "relative", marginTop: "10px" }}
//                         >
//                           <img
//                             src={formik.values.idCardFrontPreview}
//                             alt="Preview"
//                             style={{ width: "100px" }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() => handleDeletePreview("idCardFront")}
//                             style={{
//                               position: "absolute",
//                               top: "0",
//                               right: "0",
//                               background: "none",
//                               border: "none",
//                               cursor: "pointer",
//                               color: "red",
//                               fontSize: "20px",
//                             }}
//                           >
//                             🗑️
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   {/* ID Card Back */}
//                   <div className="col-lg-6">
//                     <div className="form-group">
//                       <label>ID Card (Back)</label>
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="idCardBack"
//                         onChange={(e) => handleImageChange(e, "idCardBack")}
//                       />
//                       {formik.values.idCardBackPreview && (
//                         <div
//                           style={{ position: "relative", marginTop: "10px" }}
//                         >
//                           <img
//                             src={formik.values.idCardBackPreview}
//                             alt="Preview"
//                             style={{ width: "100px" }}
//                           />
//                           <button
//                             type="button"
//                             onClick={() => handleDeletePreview("idCardBack")}
//                             style={{
//                               position: "absolute",
//                               top: "0",
//                               right: "0",
//                               background: "none",
//                               border: "none",
//                               cursor: "pointer",
//                               color: "red",
//                               fontSize: "20px",
//                             }}
//                           >
//                             🗑️
//                           </button>
//                         </div>
//                       )}
//                     </div>
//                   </div>

//                   <div className="col-lg-12">
//                     <div className="form-group">
//                       <label>
//                         <input
//                           type="checkbox"
//                           checked={isPrivacyChecked}
//                           onChange={(e) => setPrivacyChecked(e.target.checked)}
//                         />{" "}
//                         I have read, understood, and agree to be bound by the{" "}
//                         <a
//                           href="/privacypolicy"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <span style={{ color: "#ae0102" }}>
//                             {" "}
//                             Privacy Policy.
//                           </span>
//                         </a>{" "}
//                         of Auto Motor Auction{" "}
//                       </label>
//                       {/* Error message for Privacy Policy */}
//                       {!isPrivacyChecked && (
//                         <small style={{ color: "red" }}>
//                           You must agree to the Privacy Policy.
//                         </small>
//                       )}
//                     </div>

//                     <div className="form-group">
//                       <label>
//                         <input
//                           type="checkbox"
//                           checked={isRefundChecked}
//                           onChange={(e) => setRefundChecked(e.target.checked)}
//                         />{" "}
//                         I have read, understood, and agree to be bound by the{" "}
//                         <a
//                           href="/refundpolicy"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <span style={{ color: "#ae0102" }}>
//                             {" "}
//                             Refund Policy.
//                           </span>
//                         </a>{" "}
//                         of Auto Motor Auction
//                       </label>
//                       {/* Error message for Refund Policy */}
//                       {!isRefundChecked && (
//                         <small style={{ color: "red" }}>
//                           You must agree to the Refund Policy.
//                         </small>
//                       )}
//                     </div>

//                     <div className="form-group">
//                       <label>
//                         <input
//                           type="checkbox"
//                           checked={isTermsChecked}
//                           onChange={(e) => setTermsChecked(e.target.checked)}
//                         />{" "}
//                         I have read, understood, and agree to be bound by the{" "}
//                         <a
//                           href="/term&condition"
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <span style={{ color: "#ae0102" }}>
//                             {" "}
//                             Terms of Use.
//                           </span>
//                         </a>{" "}
//                         of Auto Motor Auction{" "}
//                       </label>
//                       {/* Error message for Terms of Use */}
//                       {!isTermsChecked && (
//                         <small style={{ color: "red" }}>
//                           You must agree to the Terms of Use.
//                         </small>
//                       )}
//                     </div>
//                   </div>

//                   <div className="d-flex align-items-center">
//                     <button
//                       type="submit"
//                       className="theme-btn"
//                       disabled={!isFormValid}
//                     >
//                       <i className="far fa-paper-plane"></i>
//                       {loading ? "Processing..." : "Register"}
//                     </button>
//                   </div>
//                 </div>
//               </form>
//               <div className="login-footer">
//                 <p>
//                   Already have an account? <Link to="/login">Login</Link>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default RegisterForm;

import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { axiosInstance } from "../../Api/interceptors";

const RegisterForm = () => {
  const navigate = useNavigate();

  const [isPrivacyChecked, setPrivacyChecked] = useState(false);
  const [isRefundChecked, setRefundChecked] = useState(false);
  const [isTermsChecked, setTermsChecked] = useState(false);
  const [loading, setLoading] = useState(false);

  const registerSchema = Yup.object().shape({
    first_name: Yup.string().required("Required"),
    last_name: Yup.string().required("Required"),
    username: Yup.string().required("Required"),
    email: Yup.string().email("Invalid email").required("Required"),
    password: Yup.string()
      .min(8, "Password should be of minimum 8 characters length")
      .required("Password is required"),
  });

  const verificationUrl = `https://automotor.dev-bt.xyz/emailverification/`;

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      username: "",
      email: "",
      password: "",
      dob: "",
      country: "",
      phone: "",
      driving_license_front_pic: null,
      driving_license_back_pic: null,
      passport: null,
      id_card_front: null,
      id_card_back: null,
      // previews
      driving_license_front_pic_preview: "",
      driving_license_back_pic_preview: "",
      passport_preview: "",
      id_card_front_preview: "",
      id_card_back_preview: "",
    },
    validationSchema: registerSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formdata = new FormData();

        Object.entries({ ...values, url: verificationUrl }).forEach(
          ([key, value]) => {
            if (!key.includes("_preview")) {
              formdata.append(key, value);
            }
          }
        );

        const response = await axiosInstance.post("user/register", formdata);
        if (response && response?.data) {
          toast.success("Registered Successfully");
          setLoading(false);
          navigate("/");
          toast.success("Check your email for verification link.");
        }
      } catch (errors) {
        console.error("Registration failed", errors);
        setLoading(false);
        toast.error(errors?.message || "Something went wrong");
      }
    },
  });

  // ✅ Handle image change
  const handleImageChange = (e, fieldName) => {
    const file = e.target.files[0];
    if (file) {
      formik.setFieldValue(fieldName, file);
      const previewUrl = URL.createObjectURL(file);
      formik.setFieldValue(`${fieldName}_preview`, previewUrl);
    }
  };

  // ✅ Handle delete preview
  const handleDeletePreview = (fieldName) => {
    formik.setFieldValue(fieldName, null);
    formik.setFieldValue(`${fieldName}_preview`, null);
  };

  const isFormValid = isPrivacyChecked && isRefundChecked && isTermsChecked;

  return (
    <>
      <div className="site-breadcrumb" style={{ background: "url(/assets/img/breadcrumb/01.jpg)" }}>
        <div className="container">
          <h2 className="breadcrumb-title">Register</h2>
          <ul className="breadcrumb-menu">
            <li><a href="index.html">Home</a></li>
            <li className="active">Register</li>
          </ul>
        </div>
      </div>

      <div className="login-area py-120">
        <div className="container">
          <div className="col-md-8 mx-auto">
            <div className="login-form">
              <div className="login-header">
                <img src="/assets/img/logo/1.png" alt="" />
                <p>Create your Auto Motor account</p>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  {/* Text Inputs */}
                  {[
                    { name: "first_name", label: "First Name", type: "text" },
                    { name: "last_name", label: "Last Name", type: "text" },
                    { name: "username", label: "User Name", type: "text" },
                    { name: "email", label: "Email", type: "email" },
                    { name: "password", label: "Password", type: "password" },
                    { name: "dob", label: "Date of Birth", type: "date" },
                    { name: "phone", label: "Phone", type: "text" },
                    { name: "country", label: "Country", type: "text" },
                  ].map((field) => (
                    <div className="col-lg-6" key={field.name}>
                      <div className="form-group">
                        <label>{field.label}</label>
                        <input
                          type={field.type}
                          className="form-control"
                          placeholder={field.label}
                          name={field.name}
                          onChange={formik.handleChange}
                          value={formik.values[field.name]}
                        />
                        {formik.errors[field.name] && (
                          <div className="error">{formik.errors[field.name]}</div>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* File Upload Inputs */}
                  {[
                    { name: "driving_license_front_pic", label: "Driver License (Front)" },
                    { name: "driving_license_back_pic", label: "Driver License (Back)" },
                    { name: "passport", label: "Passport" },
                    { name: "id_card_front", label: "ID Card (Front)" },
                    { name: "id_card_back", label: "ID Card (Back)" },
                  ].map((field) => (
                    <div className="col-lg-6" key={field.name}>
                      <div className="form-group">
                        <label>{field.label}</label>
                        <input
                          type="file"
                          className="form-control"
                          name={field.name}
                          onChange={(e) => handleImageChange(e, field.name)}
                        />
                        {formik.values[`${field.name}_preview`] && (
                          <div style={{ position: "relative", marginTop: "10px" }}>
                            <img
                              src={formik.values[`${field.name}_preview`]}
                              alt="Preview"
                              style={{ width: "100px" }}
                            />
                            <button
                              type="button"
                              onClick={() => handleDeletePreview(field.name)}
                              style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                color: "red",
                                fontSize: "20px",
                              }}
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                  {/* Checkboxes */}
                  <div className="col-lg-12">
                    {/* Privacy */}
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={isPrivacyChecked}
                          onChange={(e) => setPrivacyChecked(e.target.checked)}
                        />{" "}
                        I agree to the <a href="/privacypolicy" target="_blank" rel="noopener noreferrer"><span style={{ color: "#ae0102" }}> Privacy Policy</span></a>
                      </label>
                      {!isPrivacyChecked && <small style={{ color: "red" }}>You must agree to the Privacy Policy.</small>}
                    </div>

                    {/* Refund */}
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={isRefundChecked}
                          onChange={(e) => setRefundChecked(e.target.checked)}
                        />{" "}
                        I agree to the <a href="/refundpolicy" target="_blank" rel="noopener noreferrer"><span style={{ color: "#ae0102" }}> Refund Policy</span></a>
                      </label>
                      {!isRefundChecked && <small style={{ color: "red" }}>You must agree to the Refund Policy.</small>}
                    </div>

                    {/* Terms */}
                    <div className="form-group">
                      <label>
                        <input
                          type="checkbox"
                          checked={isTermsChecked}
                          onChange={(e) => setTermsChecked(e.target.checked)}
                        />{" "}
                        I agree to the <a href="/term&condition" target="_blank" rel="noopener noreferrer"><span style={{ color: "#ae0102" }}> Terms of Use</span></a>
                      </label>
                      {!isTermsChecked && <small style={{ color: "red" }}>You must agree to the Terms of Use.</small>}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="d-flex align-items-center">
                    <button type="submit" className="theme-btn" disabled={!isFormValid}>
                      <i className="far fa-paper-plane"></i>
                      {loading ? "Processing..." : "Register"}
                    </button>
                  </div>
                </div>
              </form>

              <div className="login-footer">
                <p>Already have an account? <Link to="/login">Login</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterForm;
